module.exports = __webpack_public_path__ + "static/media/logo.baf73c79.png";